import { render, staticRenderFns } from "./TestExcel_Formatted.vue?vue&type=template&id=64196b4c"
import script from "./TestExcel_Formatted.vue?vue&type=script&lang=js"
export * from "./TestExcel_Formatted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports